import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserDataService } from '@app/discoverer/app-core/user-data.service';

@Injectable({ providedIn: 'root' })
export class RoleBasedHomeGuard implements CanActivate {
    constructor(
        private userDataService: UserDataService,
        private router: Router
    ) { }

    async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const user = await this.userDataService.getUser();
        const has = (p: string) => user.roles.has(p.toLowerCase());
        const isHome = state.url === '/home';

        if (isHome) {
            if (has('drill-out:admin') || has('vchems-bol:admin')) {
                return true;
            }

            if (has('drill-out:customer')) {
                return this.router.createUrlTree(['/customer-home']);
            }

            if (has('vchems-bol:customer')) {
                return this.router.createUrlTree(['/vchems-bol/reports/bol/67da8c9a-341d-4eaa-bd42-fdff9352a82a']);
            }

            if (has('chofcd:customer')) {
                return this.router.createUrlTree(['/chofcd/completion/home']);
            }

            if (has('chofcd:admin') || has('chofcd:lab-technician')) {
                return this.router.createUrlTree(['/chofcd/production/reports/jobs']);
            }

            if (has('lab:admin')) {
                return this.router.createUrlTree(['/lab']);
            }

            return false;
        }

        return true;
    }
}
